export function conciergeTitle(country, centreSlug) {
  if (centreSlug === 'newmarket') {
    return 'Guest Services';
  }

  return country === 'New Zealand' ? 'Customer Service' : 'Concierge';
}